/* Miras · The House. Loaded by sections/miras-about.liquid. Today's hours and open/closed on each house, and visits on WhatsApp. */
(function(){
"use strict";
var R=document.querySelector('[data-mabout]');if(!R||R.__on)return;R.__on=1;
var qa=function(s,el){return [].slice.call((el||R).querySelectorAll(s));};
var C={};try{C=JSON.parse(R.querySelector('[data-macfg]').textContent);}catch(e){}
var esc=function(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});};
var wa=String((window.NXW&&NXW.wati)||R.dataset.wa||'917721895990').replace(/\D/g,'');

qa('[data-go]').forEach(function(a){a.addEventListener('click',function(e){var t=document.querySelector(a.getAttribute('href'));if(!t)return;e.preventDefault();if(window.mirasLenis)mirasLenis.scrollTo(t,{offset:-70});else t.scrollIntoView({behavior:'smooth'});});});

/* hours lines look like "Mon – Sat · 10:30 am – 9:00 pm" or "Sun · Closed" */
var DN=['sun','mon','tue','wed','thu','fri','sat'];
var dayIn=function(spec,d){spec=spec.toLowerCase();var m=spec.match(/([a-z]{3})[a-z]*\s*[–-]\s*([a-z]{3})/);
  if(m){var a=DN.indexOf(m[1]),b=DN.indexOf(m[2]);if(a<0||b<0)return false;return a<=b?d>=a&&d<=b:d>=a||d<=b;}
  return spec.split(/[,&]/).some(function(s){return DN.indexOf(s.trim().slice(0,3))===d;});};
var tmin=function(s){var m=String(s).trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/);if(!m)return null;var h=+m[1]%12;if(m[3]==='pm')h+=12;return h*60+(+m[2]||0);};
qa('[data-hours]').forEach(function(st){
  var now=new Date(),d=now.getDay(),mins=now.getHours()*60+now.getMinutes(),out=st.querySelector('[data-now]'),hit=null;
  qa('li[data-h]',st).forEach(function(li){var p=li.getAttribute('data-h').split('·');if(p.length>1&&dayIn(p[0],d)){li.classList.add('td');hit=p[1];}});
  if(!hit||!out)return;
  if(/closed/i.test(hit)){out.innerHTML='<i></i>'+esc(C.today||'Closed today');return;}
  var r=hit.split(/[–-]/),a=tmin(r[0]),b=tmin(r[1]||'');if(a==null||b==null)return;
  var open=mins>=a&&mins<b;out.classList.toggle('op',open);
  out.innerHTML='<i></i>'+esc(open?(C.open||'Open now · until [t]').replace('[t]',r[1].trim()):(mins<a?(C.opens||'Opens at [t]').replace('[t]',r[0].trim()):(C.closed||'Closed now')));
});

qa('[data-visit]').forEach(function(b){b.addEventListener('click',function(){
  window.open('https://wa.me/'+wa+'?text='+encodeURIComponent((C.visit||'').replace('[house]',b.getAttribute('data-visit'))),'_blank','noopener');});});
})();
